// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Atom_Box = require("../atom/Atom_Box.bs.js");
var Atom_Text = require("../atom/Atom_Text.bs.js");
var Util_Array = require("../../util/Util_Array.bs.js");
var Atom_Column = require("../atom/Atom_Column.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Organism_Dropdown = require("../organism/dropdown/Organism_Dropdown.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Accessibility = require("../particle/Particle_Accessibility.bs.js");
var Particle_Screen_Constants = require("../particle/Particle_Screen_Constants.bs.js");

var default_innerSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS");

var $$default = {
  styleSelect: "select",
  innerSpace: default_innerSpace
};

var mona_innerSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS");

var mona = {
  styleSelect: "mona",
  innerSpace: mona_innerSpace
};

var myProfile_innerSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS");

var myProfile = {
  styleSelect: "myProfile",
  innerSpace: myProfile_innerSpace
};

var Molecule_DatePicker_Ds = {
  $$default: $$default,
  mona: mona,
  myProfile: myProfile
};

function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* SetDay */0 :
        return {
                day: action._0,
                month: state.month,
                year: state.year
              };
    case /* SetMonth */1 :
        return {
                day: state.day,
                month: action._0,
                year: state.year
              };
    case /* SetYear */2 :
        return {
                day: state.day,
                month: state.month,
                year: action._0
              };
    
  }
}

function Molecule_DatePicker$Internal(Props) {
  var onChange = Props.onChange;
  var styleOpt = Props.style;
  var days = Props.days;
  var months = Props.months;
  var years = Props.years;
  var initialValues = Props.initialValues;
  var style = styleOpt !== undefined ? styleOpt : $$default;
  var initialState = initialValues !== undefined ? ({
        day: initialValues.day,
        month: initialValues.month,
        year: initialValues.year
      }) : ({
        day: "",
        month: "",
        year: ""
      });
  var match = React.useReducer(reducer, initialState);
  var state = match[0];
  var dispatch = match[1];
  var handleDay = function (param) {
    Curry._1(dispatch, {
          TAG: /* SetDay */0,
          _0: param.value
        });
  };
  var handleMonth = function (param) {
    Curry._1(dispatch, {
          TAG: /* SetMonth */1,
          _0: param.value
        });
  };
  var handleYear = function (param) {
    Curry._1(dispatch, {
          TAG: /* SetYear */2,
          _0: param.value
        });
  };
  React.useEffect((function () {
          Curry._1(onChange, state);
        }), [state]);
  var styleSelect = style.styleSelect;
  return React.createElement(Atom_Box.make, {
              children: null,
              direction: Particle_Screen_Ds.make(undefined, undefined, "row", undefined, undefined, "column"),
              display: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex"),
              width: Particle_Screen_Constants.oneHundredPctWidth,
              wrap: /* OnOneLine */1,
              innerSpace: style.innerSpace
            }, React.createElement(Organism_Dropdown.make, {
                  kind: {
                    TAG: /* Select */0,
                    _0: {
                      name: "day",
                      title: "day-picker",
                      autoComplete: undefined,
                      variant: styleSelect
                    }
                  },
                  items: days,
                  value: state.day,
                  onChange: handleDay
                }), React.createElement(Organism_Dropdown.make, {
                  kind: {
                    TAG: /* Select */0,
                    _0: {
                      name: "month",
                      title: "month-picker",
                      autoComplete: undefined,
                      variant: styleSelect
                    }
                  },
                  items: months,
                  value: state.month,
                  onChange: handleMonth
                }), React.createElement(Organism_Dropdown.make, {
                  kind: {
                    TAG: /* Select */0,
                    _0: {
                      name: "year",
                      title: "year-picker",
                      autoComplete: undefined,
                      variant: styleSelect
                    }
                  },
                  items: years,
                  value: state.year,
                  onChange: handleYear
                }));
}

var Internal = {
  make: Molecule_DatePicker$Internal
};

function Molecule_DatePicker(Props) {
  var onChange = Props.onChange;
  var style = Props.style;
  var days = Props.days;
  var months = Props.months;
  var years = Props.years;
  var initialValues = Props.initialValues;
  var match = Util_Array.NonEmpty.makeFromArray(days);
  var match$1 = Util_Array.NonEmpty.makeFromArray(months);
  var match$2 = Util_Array.NonEmpty.makeFromArray(years);
  if (match === undefined) {
    return null;
  }
  if (match$1 === undefined) {
    return null;
  }
  if (match$2 === undefined) {
    return null;
  }
  var tmp = {
    onChange: onChange,
    days: Caml_option.valFromOption(match),
    months: Caml_option.valFromOption(match$1),
    years: Caml_option.valFromOption(match$2)
  };
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  if (initialValues !== undefined) {
    tmp.initialValues = Caml_option.valFromOption(initialValues);
  }
  return React.createElement(Molecule_DatePicker$Internal, tmp);
}

function Molecule_DatePicker$Mona(Props) {
  var onChange = Props.onChange;
  var days = Props.days;
  var months = Props.months;
  var years = Props.years;
  var initialValues = Props.initialValues;
  var match = Util_Array.NonEmpty.makeFromArray(days);
  var match$1 = Util_Array.NonEmpty.makeFromArray(months);
  var match$2 = Util_Array.NonEmpty.makeFromArray(years);
  if (match === undefined) {
    return null;
  }
  if (match$1 === undefined) {
    return null;
  }
  if (match$2 === undefined) {
    return null;
  }
  var tmp = {
    onChange: onChange,
    style: mona,
    days: Caml_option.valFromOption(match),
    months: Caml_option.valFromOption(match$1),
    years: Caml_option.valFromOption(match$2)
  };
  if (initialValues !== undefined) {
    tmp.initialValues = Caml_option.valFromOption(initialValues);
  }
  return React.createElement(Molecule_DatePicker$Internal, tmp);
}

var Mona = {
  make: Molecule_DatePicker$Mona
};

function Molecule_DatePicker$WithError(Props) {
  var onChange = Props.onChange;
  var style = Props.style;
  var days = Props.days;
  var months = Props.months;
  var years = Props.years;
  var initialValues = Props.initialValues;
  var errorMessage = Props.errorMessage;
  var match = Util_Array.NonEmpty.makeFromArray(days);
  var match$1 = Util_Array.NonEmpty.makeFromArray(months);
  var match$2 = Util_Array.NonEmpty.makeFromArray(years);
  if (match === undefined) {
    return null;
  }
  if (match$1 === undefined) {
    return null;
  }
  if (match$2 === undefined) {
    return null;
  }
  var tmp = {
    onChange: onChange,
    style: style,
    days: Caml_option.valFromOption(match),
    months: Caml_option.valFromOption(match$1),
    years: Caml_option.valFromOption(match$2)
  };
  if (initialValues !== undefined) {
    tmp.initialValues = Caml_option.valFromOption(initialValues);
  }
  return React.createElement(Atom_Column.make, {
              children: null
            }, React.createElement(Molecule_DatePicker$Internal, tmp), React.createElement(Atom_Column.make, {
                  accessibility: Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Assertive", undefined, undefined, undefined, undefined, undefined),
                  children: errorMessage !== undefined ? React.createElement(Atom_Text.Mona.make, {
                          variant: "error",
                          children: errorMessage
                        }) : null,
                  innerSpace: Particle_Screen_Constants.xsInnerSpace,
                  kind: /* Span */8
                }));
}

var WithError = {
  make: Molecule_DatePicker$WithError
};

var make = Molecule_DatePicker;

exports.Molecule_DatePicker_Ds = Molecule_DatePicker_Ds;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
exports.mona = mona;
exports.myProfile = myProfile;
exports.reducer = reducer;
exports.Internal = Internal;
exports.make = make;
exports.Mona = Mona;
exports.WithError = WithError;
/* default Not a pure module */
